/// <reference types="@types/googlemaps" />
import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MenuItem } from 'primeng/api';
import { MassiveDeliveryRequest } from '../../../shared/api/gen_api_client/routing_pb';
import { Country } from './create.page.interface';
import { environment } from '../../../../../environments/environment';
import { Flags } from 'src/app/components/shared/types/flags.type';
import { MassiveCreateFlags } from './massive-create.flags';
import { MuLayoutService } from 'src/app/components/shared/sharedProtos/layout/mu-layout.service';
import { MuLayoutPageAndMapService } from 'src/app/components/shared/sharedProtos/layout/mu-layout-page-and-map.service';

/**
 * Import Services
 */

/**
 * Import Interface
 */

/**
 * Import Enviroments
 */

interface City {
  id: number;
  name: string;
  geoName: string;
}

interface Company {
  id: number;
  name: string;
}

interface ClientPoint {
  id: number;
  name: string;
}

interface VehicleType {
  name: string;
  id: number;
}

interface Vehicle {
  vehicleId: number;
  routingId: number;
  plate: string;
  capacity: number;
  usedCapacity: number;
  type: string;
  apiServiceId: string;
  apiServiceMessage: string;
}

interface MdDetail {
  requestId: string;
  serviceId: string;
  clientId: string;
  clientName: string;
  address: string;
  orderId: string;
  weight: string;
  phone: string;
  status: string;
  lat: string;
  lng: string;
}

interface RoutedService {
  requestId: string;
  serviceId: string;
  clientId: string;
  clientName: string;
  address: string;
  orderId: string;
  weight: string;
  phone: string;
  status: string;
  lat: string;
  lng: string;
  order: number;
}

@Component({
  selector: 'app-tabs',
  templateUrl: './create.page.component.html',
  styleUrls: ['./create.page.component.sass'],
  providers: [DatePipe],
})
export class CreatePageComponent implements OnInit {
  /**
   * The flags used in the create services process
   */
  flags = new Flags<MassiveCreateFlags>();

  items: MenuItem[];
  activeIndex = 0;
  selectedCity: City;

  clientPoints: ClientPoint[];
  selectedClientPoint: ClientPoint;

  companies: Company[] = null;
  filteredCompanies: Company[] = [];
  selectedCompany: Company;

  mdRequests: MassiveDeliveryRequest[] = null;

  selectedMdRequest: MassiveDeliveryRequest = null;

  mdRequestDetails: MdDetail[] = null;

  cities: City[] = null;
  filteredCities: City[] = [];

  startTime: Date;
  endTime: Date;
  deliveryDate: Date;

  routedServices: RoutedService[];

  options: any;
  addressOptions: any;
  overlays: any[];
  addressOverlays: any[];
  map: google.maps.Map;
  addressMap: google.maps.Map;

  loading = false;

  vehicleTypes: VehicleType[];
  selectedVehicleType: VehicleType;

  // Service progamming
  userId: number;
  zone: string;
  subZone: string;
  description: string;

  selectedCountry: Country;
  countries: Country[];

  idService: number;

  constructor(private layoutMapService: MuLayoutPageAndMapService, private layoutService: MuLayoutService) {
    this.startTime = new Date();
    this.startTime.setHours(6, 0, 0, 0);
    this.endTime = new Date();
    this.endTime.setHours(18, 0, 0, 0);
    this.deliveryDate = new Date();
    this.deliveryDate.setDate(this.deliveryDate.getDate() + 1);
    this.idService = 0;
    this.countries = environment.countries;
    this.layoutMapService.setup({
      columnSize: {
        startColumn: 8,
        endColumn: 4,
      },
    });
    this.layoutService.currentCountryValue.subscribe(countryVal => {
      const result = this.countries.filter(item => item.geoName === countryVal);
      this.selectedCountry = result[0];
    });
  }

  ngOnInit() {
    this.vehicleTypes = [
      { name: 'MOTO', id: 1 },
      { name: 'CAMIÓN', id: 2 },
      { name: 'MIXTO', id: 3 },
    ];

    this.selectedVehicleType = this.vehicleTypes[0];

    this.items = [{ label: 'Cargar Información' }, { label: 'Verificar Información' }, { label: 'Programar Servicios' }];

    this.options = {
      center: { lat: 4, lng: 72 },
      zoom: 12,
    };

    this.addressOptions = {
      center: { lat: 4, lng: 72 },
      zoom: 12,
    };
  }

  filterCities($event) {
    this.filteredCities = [];
    this.cities.forEach(city => {
      if (city.name.toLowerCase().indexOf($event.query.toLowerCase()) === 0) {
        this.filteredCities.push(city);
      }
    });
  }

  filterCompanies($event) {
    this.filteredCompanies = [];
    this.companies.forEach(city => {
      if (city.name.toLowerCase().indexOf($event.query.toLowerCase()) === 0) {
        this.filteredCompanies.push(city);
      }
    });
  }

  updateActiveTab(numberTab) {
    this.activeIndex = numberTab;
  }

  handleChange(e) {
    this.updateActiveTab(e.index);
  }

  updateIsServiceInitial(idService) {
    this.idService = idService;
    this.activeIndex = 1;
  }

  updateIsService(idService) {
    this.idService = idService;
  }
}
